import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.scss'
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import Logo from '../../Assets/imges/Logo.png'
import { FaSnapchatGhost } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

export default function Footer() {

    const { t } = useTranslation();

    return <div className="Footer py-20">
        <div className="mx-auto w-full max-w-screen-xl">
            <div className="flex flex-wrap py-6 lg:py-8 px-5 Footer_Sections">
                <div className='Footer_Important'>
                    <h2 className="mb-3 text-lg font-semibold text-[rgb(188,113,113)] uppercase">
                        {t("Information")}
                    </h2>
                    <ul className="text-gray-500 font-medium">
                        <li className="mb-1">
                            <Link className="Title" to='/FaQ'>{t("FAQ")}</Link>
                        </li>
                        <li className="mb-1">
                            <Link className="Title" to='/Refund'>{t("RefundAndExchange")}</Link>
                        </li>
                        <li className="mb-1">
                            <Link className="Title" to='/Policy'>{t("PrivacyAndPolicy")}</Link>
                        </li>
                    </ul>
                </div>
                <div className='Footer_Logo'>
                    <img src={Logo} alt="Logo" width={"170"} height={"170"} />
                    <div className="flex w-full justify-center gap-x-3 items-center mt-2 relative right-1">
                        <a href="https://www.facebook.com/share/5MtSyMqW9kanUmck/?mibextid=LQQJ4d" aria-label='Mema Facebook'>
                            <FaFacebookF className='Socials' />
                        </a>
                        <a href="https://www.instagram.com/mema.hijabi?igsh=Mm1iazlhODhzNGZq&utm_source=qr"
                            className="text-gray-500 transition hover:text-[#bc7171]" aria-label='Mema Instgram'>
                            <FaInstagram className='Socials' />
                        </a>
                        <a href="https://www.tiktok.com/@mema.hijabi?_t=8piQyUowLbj&_r=1" aria-label='Mema TikTok'
                            className="text-gray-500 transition hover:text-[#bc7171]">
                            <FaTiktok className='Socials' />

                        </a>
                        <a href='https://wa.me/+201021205001?' aria-label='Mema Whats up'
                            className="text-gray-500 transition hover:text-[#bc7171]">
                            <FaWhatsapp className='Socials' />

                        </a>
                        <a href='https://snapchat.com/t/6xtR8TYz' aria-label='Mema Snap Chat'
                            className="text-gray-500 transition hover:text-[#bc7171]">
                            <FaSnapchatGhost className='Socials' />

                        </a>
                    </div>
                </div>
                <div className='Footer_Connection'>
                    <h2 className="mb-3 text-lg font-semibold text-[rgb(188,113,113)] uppercase">
                        {t("Connection")}
                    </h2>
                    <ul className="text-gray-500 font-medium">
                        <li className="mb-1 Title">
                            {t("Email")} : Memahijabi@gmail.com
                        </li>
                        <li className="mb-1 Title">
                            {t("Egy")} : +201021205001
                        </li>
                        <li className="mb-1 Title">
                            {t("Sud")} : +966542088746
                        </li>
                    </ul>
                </div>
            </div>
            <div className="sm:flex sm:items-center sm:justify-between Links pt-10 px-4">
                <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
                    {t("Rights")}
                </span>
                {/* <div className="flex mt-4 sm:justify-center sm:mt-0">
                    <a href="https://www.facebook.com/share/5MtSyMqW9kanUmck/?mibextid=LQQJ4d"
                        className="text-gray-500 transition hover:text-[#bc7171] mx-2">
                        <FaFacebookF className='w-4 h-4' />
                        <span className="sr-only">Facebook page</span>
                    </a>
                    <a href="https://www.instagram.com/mema.hijabi?igsh=Mm1iazlhODhzNGZq&utm_source=qr"
                        className="text-gray-500 transition hover:text-[#bc7171] mx-2">
                        <FaInstagram className='w-4 h-4' />
                        <span className="sr-only">Instagram page</span>
                    </a>
                    <a href="https://www.tiktok.com/@mema.hijabi?_t=8piQyUowLbj&_r=1"
                        className="text-gray-500 transition hover:text-[#bc7171] mx-2">
                        <FaTiktok className='w-4 h-4' />
                        <span className="sr-only">Tiktok page</span>
                    </a>
                    <a href='https://wa.me/+201021205001?'
                        className="text-gray-500 transition hover:text-[#bc7171] mx-2">
                        <FaWhatsapp className='w-4 h-4' />
                        <span className="sr-only">Whatsapp</span>
                    </a>
                    <a href='https://wa.me/+201021205001?'
                        className="text-gray-500 transition hover:text-[#bc7171] mx-2">
                        <FaSnapchatGhost className='w-4 h-4' />
                        <span className="sr-only">SnapChat</span>
                    </a>
                </div> */}
            </div>
        </div>
    </div>

}
